import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-fecha-corte',
  templateUrl: './modal-fecha-corte.component.html',
  styleUrl: './modal-fecha-corte.component.scss',
})
export class ModalFechaCorteComponent {
  @ViewChild('modalFechaCorteButton') modalFechaCorteButton!: ElementRef;
  @Output() fechaSeleccionada = new EventEmitter<Date>();
  fecha: Date | null = null;
  fechaMaxima: string;

  constructor() {
    // Establecer la fecha máxima como la fecha actual
    const hoy = new Date();
    const dia = hoy.getDate().toString().padStart(2, '0');
    const mes = (hoy.getMonth() + 1).toString().padStart(2, '0'); // Los meses empiezan en 0
    const anio = hoy.getFullYear();
    this.fechaMaxima = `${anio}-${mes}-${dia}`;
  }

  // Método para emitir la fecha seleccionada
  guardarFecha() {
    if (!this.fecha) {
      alert('Por favor, seleccione una fecha válida.');
      return;
    }
    const fechaIngresada = new Date(this.fecha);
    // Emitir la fecha si es válida
    this.fechaSeleccionada.emit(fechaIngresada);
  }

  // Método para abrir o cerrar el modal utilizando el botón oculto
  abrirCerrarModal() {
    this.modalFechaCorteButton.nativeElement.click();
  }
}